import { tokens } from './tokens';
import { typography } from './typography';

export const theme = {
  ...tokens,
  typography,
  
  // High-level UI patterns
  sidebar: {
    width: '280px',
    collapsedWidth: '80px',
    background: 'var(--sidebar-bg)', 
    text: 'var(--sidebar-text)',
    activeBackground: '#FFFFFF',
    activeText: '#000000',
    hoverBackground: 'rgba(255, 255, 255, 0.1)',
  },
  
  card: {
    borderRadius: '8px',
    background: 'var(--bg-surface)',
    border: '1px solid var(--border-color)',
    shadow: tokens.shadows.sm,
  },
  
  button: {
    borderRadius: '6px',
    padding: `${tokens.spacing.sm} ${tokens.spacing.md}`,
  },

  layout: {
    maxWidth: '1366px',
    contentPadding: tokens.spacing.lg,
    background: 'var(--bg-muted)',
    text: 'var(--text-primary)',
    textSecondary: 'var(--text-secondary)',
  }
};

export type Theme = typeof theme;
